<template>
    <div class="ft-modal-container">
        <b-modal id="ft-vehicle-types-modal" class="ft-vehicle-types-modal" hide-footer @show="updateTempSelectedTypes" title="select-vehicle-types">
            <template v-slot:modal-header>
                <h5>{{$t('message.selectVehicleModalTitle')}}</h5>
            </template>
            <b-container style="padding: 0">
                <!-- <b-row class="ft-modal-header">
                    <b-col cols="12">
                    <h4>Select vehicle type</h4>
                    </b-col>
                </b-row> -->
                <!-- <b-row>
                        <div> -->
                            <b-card no-body style="border: none">
                                <b-tabs card class="tab-vehicle-types">
                                    <b-tab v-for="vehicle in vehicleTypesList" v-bind:key="vehicle.type">
                                        <template #title>
                                            <icon-base icon-name="open-truck" width="24" height="24" viewBox="0 0 24 24">
                                                <component v-bind:is="currentIconComponent(vehicle.type)"></component>
                                            </icon-base>
                                            <div class="tab-title">
                                            {{ vehicle.type }}
                                            </div>

                                        </template>
                                        <b-card-text v-for="(category, idx) in vehicle.categories" v-bind:key="idx">
                                            <div v-b-toggle="'collapse-'+idx">{{idx}}</div>
                                            <b-collapse :id="'collapse-'+idx" visible>
                                                <ul class="vehicle-list">
                                                    <li class="vehicle-list-item" v-for="cat in category" v-bind:key="cat.id" @click="handleSelectSingleVehicle(cat)">
                                                        <b-form-checkbox v-if="type == 'multiple'" :value="cat" :name="idx" v-model="tempselectedVehicleTypes.selected">
                                                            {{cat.label}}
                                                            {{tempselectedVehicleTypes[cat.id]}}
                                                        </b-form-checkbox>
                                                        <span v-if="type == 'single'">
                                                            {{cat.label}}
                                                        {{tempselectedVehicleTypes[cat.id]}}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </b-collapse>
                                        </b-card-text>
                                    </b-tab>

                                    <!-- <b-tab v-for="vehicle in vehicleTypes" v-bind:key="vehicle.type" :title="vehicle.type">
                                        <b-card-text v-for="(category, idx) in vehicle.categories" v-bind:key="idx">
                                            {{idx}}
                                            <ul>
                                                <li v-for="cat in category" v-bind:key="cat.id">
                                                    <b-form-checkbox :value="cat.id">
                                                    {{cat.label}}
                                                    </b-form-checkbox>
                                                </li>
                                            </ul>
                                        </b-card-text>
                                    </b-tab> -->
                                </b-tabs>
                            </b-card>
                        <!-- </div>

                </b-row> -->
            </b-container>


            <div class="modal-footer" v-if="type == 'multiple'">
                <div>
                    <div class="ft-modal-form-control">
                        <b-button class="mr-2" variant="secondary" @click="resetTemp">{{$t('message.modalCancelBtnText')}}</b-button>
                        <b-button variant="primary" @click="updateVehicleTypes" :disabled="tempselectedVehicleTypes.selected.length == 0">{{$t('message.modalAddBtnText')}}</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconClosedTruck from '../icons/IconClosedTruck.vue'
import IconOpenTruck from '../icons/IconOpenTruck.vue'
import IconDumperTruck from '../icons/IconDumperTruck.vue'
import IconTrailerTruck from '../icons/IconTrailerTruck.vue'
import axios from 'axios'

// import Config from '../config/config.js'
const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL

export default {
    props: {
        vehicleTypes: [Array, Object],
        type: String
    },
    components: {
        IconBase,
        IconClosedTruck,
        IconOpenTruck,
        IconDumperTruck,
        IconTrailerTruck
    },
    data() {
        return {
            vehicleTypesList: [],
            selectedVehicleTypes: [],
            tempselectedVehicleTypes: {
                selected: []
            },
        }
    },
    methods: {
        currentIconComponent(type) {
            const truckIcons = {
                "open": IconOpenTruck,
                "closed": IconClosedTruck,
                "dumper": IconDumperTruck,
                "trailer": IconTrailerTruck
            }
            return (truckIcons[type.toLowerCase()]) ? truckIcons[type.toLowerCase()] : truckIcons.closed
        },
        async getVehicleTypes() {
            try {
                const {data} = await axios.get(`${API_BASE_URL}/vehicle_types/structured`)
                if (data.success) {
                    this.vehicleTypesList = data.value
                }
            } catch (error) {
                console.log(error)
            }

        },
        onSelectTrucks(e, truck) {
            if (!e) {
                delete this.selectedVehicleTypes[truck.id]
                return
            }
            this.selectedVehicleTypes[truck.id] = truck
        },
        updateVehicleTypes() {
            this.selectedVehicleTypes = this.tempselectedVehicleTypes.selected
            this.$emit('update-vehicle-types', this.selectedVehicleTypes)

            this.resetTemp()
        },
        handleSelectSingleVehicle(vehicle) {
            if (this.type == "single") {
                // this.selectedVehicleTypes = vehicle
                this.$emit('update-vehicle-types', vehicle)
                this.$bvModal.hide('ft-vehicle-types-modal')
            }

        },
        createReqData() {
            const vehicle_types = []
            for (const key in this.selectedVehicleTypes) {
                vehicle_types.push({
                    vehicle_type_id: this.selectedVehicleTypes[key].id,
                    vehicle_label: this.selectedVehicleTypes[key].label,
                    quantity: 1
                })
            }

            return vehicle_types
        },
        updateTempSelectedTypes() {
            this.tempselectedVehicleTypes.selected = (Array.isArray(this.vehicleTypes)) ? [...this.vehicleTypes] : {}
        },
        resetTemp() {
            this.$bvModal.hide('ft-vehicle-types-modal')
            this.tempselectedVehicleTypes = {
                selected: []
            }
        }
    },
    mounted() {
        this.getVehicleTypes()
    }

}
</script>

<style lang="scss">

.ft-modal-container {
    display: inline;
}


.ft-button-link {
    margin: 10px 0 10px 20px;
    color: #1F1F1F;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;

    &:hover {
        text-decoration: none;
        color: #1F1F1F;

    }

    &:focus {
        text-decoration: none;
        box-shadow: none;
    }
}

.ft-modal-form-control {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;

}

.tab-vehicle-types {
    .card-header-tabs {
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;

            .nav-item {
                .nav-link {
                    .tab-title {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 20px;
                    }

                }
            }
    }
    .card-text {
        font-size: 14px;
        line-height: 20px;
        color: #1F1F1F;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
        .collapsed{
            &::after {
                content: url('../../assets/images/accordion-down.png');
                float: right;
            }
        }
        .not-collapsed{
            &::after {
                content: url('../../assets/images/accordion-up.png');
                float: right;
            }
        }
    }
    .tab-pane {
        &.card-body {
            min-height: 360px;
            max-height: 360px;
            overflow-y: auto;
        }

    }
}


.vehicle-list {
    padding: 0;
    margin-top: 1rem;
    .vehicle-list-item {
        list-style: none;
        padding: 5px 0;
    }
}
</style>
